import React from "react";
import { Card } from "antd";

interface Stats {
  active: number;
  waiting: number;
  closed: number;
  total: number;
}

interface StatsCardsProps {
  stats: Stats;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  const cards = [
    {
      label: "Active",
      value: stats.active,
      color: "bg-green-500",
    },
    {
      label: "Waiting",
      value: stats.waiting,
      color: "bg-yellow-500",
    },
    {
      label: "Closed",
      value: stats.closed,
      color: "bg-gray-500",
    },
    {
      label: "Total",
      value: stats.total,
      color: "bg-blue-500",
    },
  ];

  return (
    <div className="flex items-center justify-between w-full">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 w-full">
        {cards.map((card) => (
          <Card
            key={card.label}
            className="vi-glass-card w-full shadow-md hover:shadow-lg transition-shadow duration-200 border-l-4"
          >
            <div className="text-left px-1 sm:px-2">
              <div className="flex items-center gap-1 sm:gap-2 mb-1 sm:mb-2">
                <div className={`w-2 h-2 rounded-full ${card.color}`}></div>
                <div className="text-xs sm:text-sm text-gray-600 font-medium">
                  {card.label}
                </div>
              </div>
              <div className="text-xl sm:text-3xl font-bold">{card.value}</div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default StatsCards;
